import styled from 'styled-components';
import Icon from 'components/base/Icon';
import { Margin } from 'components/base/layout-components';
import { Tooltip } from '@material-ui/core';

const StyledIconWithLabel = styled.div`
  display: flex;
  align-items: center;
`;

const IconWithLabel = ({ iconName, text, tooltipText }) => {
  return (
    <StyledIconWithLabel>
      <Icon name={iconName} color='shuttleGray' />
      <Tooltip
        title={<div className='max-w-96'>{tooltipText}</div>}
        disableHoverListener={!tooltipText}
      >
        <Margin l='smaller'>{text}</Margin>
      </Tooltip>
    </StyledIconWithLabel>
  );
};

export default IconWithLabel;
